<template lang="pug">
    v-dialog(v-model='dialog' scrollable persistent max-width='900px')
        template(v-slot:activator='{ on }')
            v-btn(v-if="validScorecardCriterion" icon small light v-on='on' @click="init();")
                v-icon mdi-circle-edit-outline
            v-btn(v-else outlined color="success" small light v-on='on' @click="init();")
                v-icon(color="success") mdi-plus
                | Add Criterion

        v-card(v-if="formScorecardCriterion")
            v-card-title
                span.text-h5(v-if='validScorecardCriterion') Edit Scorecard Criterion
                span.text-h5(v-else) Create Scorecard Criterion
            v-card-text
                v-container
                    v-row
                        v-col(cols='6')
                            v-autocomplete(v-model='formScorecardCriterion.communication_type' :items='communicationTypes' label='Communication Type' item-text="key" item-value="value")
                        v-col(cols='6')
                            v-autocomplete(v-model='formScorecardCriterion.status' :items='statuses' label='Status' item-text="key" item-value="value")
                        v-col(cols='12')
                            v-autocomplete(v-model='formScorecardCriterion.organization_ids' multiple :items='organizationUsers' :loading="isLoadingOrganizations" label='Organization(s)' item-text="organization_name" item-value="organization_id" clearable @change="handleSelectOrganizations();")
                        v-col(cols='12')
                            v-autocomplete(v-model='formScorecardCriterion.campaign_ids' multiple :items='campaigns' :loading="isLoadingCampaigns" :disabled="!((formScorecardCriterion.organization_ids || []).length > 0 && campaigns.length > 0)" label='Campaign(s)' item-text="campaign_name" item-value="campaign_id" clearable)
                        v-col(cols='12')
                            v-autocomplete(v-model='formScorecardCriterion.user_ids' multiple :items='users' :loading="isLoadingUsers" label='User(s)' item-text="display_name" item-value="user_id" clearable)
                        v-col(cols='12')
                            v-autocomplete(v-model='formScorecardCriterion.campaign_type_ids' multiple :items='campaignTypes' :loading="isLoadingCampaignTypes" label='Campaign Type(s)' item-text="name" item-value="campaign_type_id" clearable)
                        v-col(cols='12')
                            v-autocomplete(v-model='formScorecardCriterion.disposition_ids' multiple :items='dispositions' :loading="isLoadingDispositions" label='Disposition(s)' item-text="disposition_description" item-value="disposition_id" clearable)

            v-card-actions
                v-row
                    v-col(cols='12')
                        .text-right
                            v-btn.ma-2(outlined ripple @click="dialog = false;")
                                v-icon mdi-window-close
                                | Cancel

                            v-btn.ma-2.white--text(v-if="validScorecardCriterion" :disabled="!eligibleToSave" :loading="isSaving" ripple color="green" @click="updateScorecardCriterion()")
                                v-icon mdi-content-save
                                | Save

                            v-btn.ma-2.white--text(v-else :disabled="!eligibleToSave" :loading="isSaving" ripple color="green" @click="createScorecardCriterion()")
                                v-icon mdi-content-save
                                | Save

</template>

<script lang="ts">
    import Vue from 'vue';

    // Data
    import { 
        CreateScorecardCriterion,
        GetCampaigns,
        GetCampaignTypes,
        GetDispositions,
        GetOrganizationUsers,
        GetUsers,
        UpdateScorecardCriterion,
    } from "@/data";


    // Components
    import StatusText from '@/components/shared/status_text.vue';

    export default Vue.extend({
        data() {
            return {
                campaignTypes: [],
                campaigns: [],
                communicationTypes: [
                    {
                        key: 'Call',
                        value: 'call',
                    },
                    // {
                    //     key: 'Email',
                    //     value: 'email',
                    // },
                    // {
                    //     key: 'Email Thread',
                    //     value: 'email_thread',
                    // },
                    // {
                    //     key: 'Inbound Call',
                    //     value: 'inbound_call',
                    // },
                    // {
                    //     key: 'Outbound Call',
                    //     value: 'outbound_call',
                    // },
                    // {
                    //     key: 'Outbound Call',
                    //     value: 'outbound_call',
                    // },
                    // {
                    //     key: 'SMS Conversation',
                    //     value: 'conversation',
                    // },
                    // {
                    //     key: 'SMS Message',
                    //     value: 'sms_message',
                    // },
                ],
                dialog: false,
                dispositions: [],
                formScorecardCriterion: {
                    communication_type: null,
                    campaign_ids: null,
                    disposition_ids: null,
                    organization_ids: null,
                    status: 'active',
                    user_ids: null,
                },
                isLoadingCampaigns: false,
                isLoadingCampaignTypes: false,
                isLoadingDispositions: false,
                isLoadingOrganizations: false,
                isLoadingUsers: false,
                isSaving: false,
                organizationUsers: [],
                statuses: [
                    {
                        key: 'Active',
                        value: 'active',
                    },
                    {
                        key: 'Draft',
                        value: 'draft',
                    },
                ],
                users: [],
            }
        },
        methods: {
            createScorecardCriterion() {
                if (!this.validScorecardTemplate) {
                    return;
                }

                const options = {
                    campaign_ids: this.formScorecardCriterion?.campaign_ids || [],
                    campaign_type_ids: this.formScorecardCriterion?.campaign_type_ids || [],
                    communication_type: this.formScorecardCriterion?.communication_type || '',
                    disposition_ids: this.formScorecardCriterion?.disposition_ids || [],
                    organization_ids: this.formScorecardCriterion?.organization_ids || [],
                    status: this.formScorecardCriterion?.status || '',
                    user_ids: this.formScorecardCriterion?.user_ids || [],
                }

                this.isSaving = true;
                CreateScorecardCriterion(this.scorecardTemplate.scorecard_template_id, options).then((response) => {
                    if (response?.Data?.scorecard_criterion?.scorecard_criterion_id > 0) {

                        this.handleCreateScorecardCriterion(response.Data.scorecard_criterion);
                        this.showSnackbar("success", "Successfully created scorecard criterion")
                    } else {
                        this.showSnackbar("error", "Unable to create scorecard criterion")
                    }

                    this.isSaving = false;
                    this.dialog = false;
                });
            },
            getCampaigns() {
                if (!(this.formScorecardCriterion?.organization_ids?.length > 0)) {
                    this.campaigns = [];
                    this.formScorecardCriterion.campaign_ids = [];
                    return;
                }

                const options = {
                    organization_ids: this.formScorecardCriterion.organization_ids || [],
                }

                this.isLoadingCampaigns = true;
                GetCampaigns(options).then((response) => {

                    // For use when Filter/remove selected campaign ids if no longer in campaigns array. i.e. org1 selected, org1's campaign campaign_1 selected, then org1 deselected, remove campaign_1 from selected campaign ids 
                    const availableCampaignIds :any[] = [];

                    if (response?.Data?.campaigns?.length > 0) {


                        // ordered by organization_name asc, campaign_name asc
                        // this groups campaign select dropdown options
                        const ungroupedCampaigns = response.Data.campaigns;
                        const groupedCampaigns :any[]  = [];

                        for (let i = 0; i < ungroupedCampaigns.length; i++) {
                            if ((i === 0) || (ungroupedCampaigns[i-1]?.organization_id !== ungroupedCampaigns[i]?.organization_id)) {
                                groupedCampaigns.push({header: ungroupedCampaigns[i].organization_name});
                            }

                            groupedCampaigns.push(ungroupedCampaigns[i]);
                            availableCampaignIds.push(ungroupedCampaigns[i].campaign_id);
                        }
            
                        this.campaigns = groupedCampaigns;
                    }

                    // Filter/remove selected campaign ids if no longer in campaigns array. i.e. org1 selected, org1's campaign campaign_1 selected, then org1 deselected, remove campaign_1 from selected campaign ids
                    if (this.formScorecardCriterion?.campaign_ids > 0) {

                        const searchCampaignIds :any[] = [];
                        for (let i=0; i < this.formScorecardCriterion.campaign_ids.length; i++) {
                            if (availableCampaignIds.includes(this.formScorecardCriterion.campaign_ids[i])) {
                                searchCampaignIds.push(this.formScorecardCriterion.campaign_ids[i]);
                            }
                        }

                        this.formScorecardCriterion.campaign_ids = searchCampaignIds;
                    }

                    this.isLoadingCampaigns = false;
                });
            },
            getCampaignTypes() {
                this.isLoadingCampaignTypes = true;
                GetCampaignTypes({}).then((response) => {
                    if (response.Data?.campaign_types?.length > 0) {
                        this.campaignTypes = response.Data.campaign_types;
                    }

                    this.isLoadingCampaignTypes = false;
                });
                return;
            },
            getDispositions() {
                this.isLoadingDispositions = true;
                GetDispositions({ limit: 1000 }).then((response) => {
                    if (response?.Data?.dispositions?.length > 0) {
                        this.dispositions = response.Data.dispositions;
                    }

                    this.isLoadingDispositions = false;
                });
                return;
            },
            getOrganizationUsers() {
                this.isLoadingOrganizations = true;
                GetOrganizationUsers().then((response) => {
                    if (response?.Data?.organization_users?.length > 0) {
                        this.organizationUsers = response.Data.organization_users;
                    }

                    this.isLoadingOrganizations = false;
                });
                return;
            },
            getUsers() {
                this.isLoadingUsers = true;
                GetUsers({ user_dropdown: true }).then((response) => {
                    if (response?.Data?.users?.length > 0) {
                        this.users = response.Data.users;
                    }

                    this.isLoadingUsers = false;
                });
                return;
            },
            handleSelectOrganizations() {
                // this.formScorecardCriterion.campaign_ids = [];
                this.campaigns = [];
                this.getCampaigns();
                return;
            },
            init() {
                if (this.validScorecardCriterion) {
                    this.formScorecardCriterion = {...this.scorecardCriterion};
                } else {
                    this.formScorecardCriterion = {
                        communication_type: 'call',
                        campaign_ids: null,
                        campaign_type_ids: null,
                        disposition_ids: null,
                        organization_ids: null,
                        status: 'active',
                        user_ids: null,
                    }
                }

                this.getCampaigns();
                this.getCampaignTypes();
                this.getDispositions();
                this.getOrganizationUsers();
                this.getUsers();
                return;
            },
            updateScorecardCriterion() {
                if (!this.validScorecardTemplate || !this.validScorecardCriterion) {
                    return;
                }

                const options = {
                    campaign_ids: this.formScorecardCriterion.campaign_ids || [],
                    campaign_type_ids: this.formScorecardCriterion.campaign_type_ids || [],
                    communication_type: this.formScorecardCriterion?.communication_type || '',
                    disposition_ids: this.formScorecardCriterion.disposition_ids || [],
                    organization_ids: this.formScorecardCriterion.organization_ids || [],
                    status: this.formScorecardCriterion?.status || '',
                    user_ids: this.formScorecardCriterion.user_ids || [],
                }

                this.isSaving = true;
                UpdateScorecardCriterion(this.scorecardTemplate.scorecard_template_id, this.scorecardCriterion.scorecard_criterion_id, options).then((response) => {
                    if (response?.Data?.scorecard_criterion?.scorecard_criterion_id > 0) {

                        this.handleUpdateScorecardCriterion(response.Data.scorecard_criterion);
                        this.showSnackbar("success", "Successfully updated scorecard criterion")
                    } else {
                        this.showSnackbar("error", "Unable to update scorecard criterion")
                    }

                    this.isSaving = false;
                    this.dialog = false;
                });
            },
        },
        computed: {
            eligibleToSave() {
                if (!(this.formScorecardCriterion?.communication_type?.length)) {
                    return false;
                }
                if (!(this.formScorecardCriterion?.status?.length)) {
                    return false;
                }

                return true;
            },
            validScorecardCriterion() {
                return this.scorecardCriterion?.scorecard_criterion_id > 0;
            },
            validScorecardTemplate() {
                return this.scorecardTemplate?.scorecard_template_id > 0;
            },
        },
        props: {
            handleCreateScorecardCriterion: Function,
            handleUpdateScorecardCriterion: Function,
            scorecardCriterion: Object,
            scorecardTemplate: Object,
            showSnackbar: Function,
        },
    });
</script>

<style lang="scss" scoped>
    #app {

    }
</style>
